<template>
<div class="flex flex-row flex-wrap overflow-y-scroll max-h-96 prose">
    <div class="marketing-block marketing-block--light marketing-block--padded">
        <h3 class="w-full">Shipping policy</h3>
        <p><strong><em>It's important to start by clarifying to customers that your order processing times are separate from the shipping times they see at checkout.&nbsp;</em></strong></p>
        <p>All orders are processed within X to X business days (excluding weekends and holidays) after receiving your order confirmation email. You will receive another notification when your order has shipped.&nbsp;</p>
        <p><strong><em>Include any other pertinent information towards the beginning, such as potential delays due to a high volume of orders or postal service problems that are outside of your control.</em></strong></p>
        <h3>Domestic Shipping Rates and Estimates</h3>
        <p><strong><em>For&nbsp;calculated shipping rates:&nbsp;</em></strong>Shipping charges for your order will be calculated and displayed at checkout.&nbsp;</p>
        <p><strong><em>For&nbsp;simple flat rate shipping:</em></strong><em>&nbsp;</em>We offer $X flat rate shipping to [list countries].&nbsp;</p>
        <p><strong><em>You can also&nbsp;emphasize&nbsp;any free shipping thresholds you offer (e.g. free shipping for orders over $75).</em></strong><strong><em>&nbsp;For multiple shipping options</em></strong><strong><em>, you can list carrier options, prices, and delivery times in a table.</em></strong></p>
        <table border="solid black">
            <tbody>
                <tr>
                    <td>
                        <p><strong>Shipping option</strong></p>
                    </td>
                    <td>
                        <p><strong>Estimated delivery time</strong></p>
                    </td>
                    <td>
                        <p><strong>Price</strong></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Option 1</p>
                    </td>
                    <td>
                        <p>X to X business days</p>
                    </td>
                    <td>
                        <p>$X</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Option 2</p>
                    </td>
                    <td>
                        <p>X to X business days</p>
                    </td>
                    <td>
                        <p>$X</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Option 3</p>
                    </td>
                    <td>
                        <p>X to X business days</p>
                    </td>
                    <td>
                        <p>$X</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <h4></h4>
        <h3>Local delivery</h3>
        <p><strong><em>If you offer local delivery or in-store pickup to customers in your area, you can dedicate a section of your shipping policy page to explain the process or create a separate shipping page specifically for local customers.&nbsp;</em></strong><em><br></em></p>
        <p>Free local delivery is available for orders over $X within [area of coverage]. For orders under $X, we charge $X for local delivery.</p>
        <p>Deliveries are made from [delivery hours] on [available days]. We will contact you via text message with the phone number you provided at checkout to notify you on the day of our arrival.&nbsp;</p>
        <p><strong><em>You can list out the ZIP/postal codes you service and/or consider embedding a map here so customers can easily see if they are within your local delivery range.</em></strong></p>
        <h3>In-store pickup</h3>
        <p>You can skip the shipping fees with free local pickup at [list the locations where in-store pickup is available]. After placing your order and selecting local pickup at checkout, your order will be prepared and ready for pick up within X to X business days. We will send you an email when your order is ready along with instructions.&nbsp;</p>
        <p>Our in-store pickup hours are [store hours] on [available days of the week]. Please have your order confirmation email with you when you come.</p>
        <h3>International Shipping</h3>
        <p>We offer international shipping to the following countries: [list of countries].&nbsp;</p>
        <p><strong><em>If relevant you can also include countries you don’t ship to:</em></strong>&nbsp;At this time, we do not ship to [list of countries].&nbsp;</p>
        <p><strong><em>If you’re using calculated shipping rates:&nbsp;</em></strong>Shipping charges for your order will be calculated and displayed at checkout.&nbsp;</p>
        <meta charset="utf-8">
        <p><strong><em>If you offer multiple international shipping options, you can list them in a table as well. You can include broader delivery timelines (e.g. 8 to 20 days) for international shipping since expectations can vary greatly depending on the destination.</em></strong></p>
        <table border="solid black">
            <tbody>
                <tr>
                    <td>
                        <p><strong>Shipping option</strong></p>
                    </td>
                    <td>
                        <p><strong>Estimated delivery time</strong></p>
                    </td>
                    <td>
                        <p><strong>Price</strong></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Option 1</p>
                    </td>
                    <td>
                        <p>X to X business days</p>
                    </td>
                    <td>
                        <p>$X</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Option 2</p>
                    </td>
                    <td>
                        <p>X to X business days</p>
                    </td>
                    <td>
                        <p>$X</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Option 3</p>
                    </td>
                    <td>
                        <p>X to X business days</p>
                    </td>
                    <td>
                        <p>$X</p>
                    </td>
                </tr>
            </tbody>
        </table>
        <p>&nbsp;</p>
        <p>Your order may be subject to import duties and taxes (including VAT), which are incurred once a shipment reaches your destination country. [Your Company] is not responsible for these charges if they are applied and are your responsibility as the customer.</p>
        <h3>How do I check the status of my order?</h3>
        <p>When your order has shipped, you will receive an email notification from us which will include a tracking number you can use to check its status. Please allow 48 hours for the tracking information to become available.&nbsp;</p>
        <meta charset="utf-8">
        <p>If you haven’t received your order within X days of receiving your shipping confirmation email, please contact us at support@email.com with your name and order number, and we will look into it for you.</p>
        <p><strong><em>Include a link for customers to track their order if available.</em></strong></p>
        <h3>Shipping to P.O. boxes</h3>
        <p><em><strong>Some carriers have limitations around shipping to P.O. Boxes. If one of your carriers falls into this group, you should look up their policy and communicate it to your customers here.&nbsp;</strong></em></p>
        <h3>Refunds, returns, and exchanges</h3>
        <p><strong><em>Summarize your return policy here and link out to your full </em></strong><a href="/blog/return-policy"><strong><em>return policy page</em></strong></a><strong><em> if you have one.&nbsp;</em></strong></p>
        <p>We accept returns up to X days after delivery, if the item is unused and in its original condition, and we will refund the full order amount minus the shipping costs for the return.&nbsp;</p>
        <p>In the event that your order arrives damaged in any way, please email us as soon as possible at support@email.com with your order number and a photo of the item’s condition. We address these on a case-by-case basis but will try our best to work towards a satisfactory solution.</p>
        <p>If you have any further questions, please don't hesitate to contact us at support@email.com.</p>
    </div>
</div>
</template>

<script>
export default {
    name: "Shipping"
}
</script>
